<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR FUNÇÃO GRATIFICADA' : 'NOVA FUNÇÃO GRATIFICADA'" titleIcon="fas fa-hand-holding-usd">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="$requiredBlur">
                            <el-input v-model="dados.nome" placeholder="Ex.: Coordenação de Turno"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Código">
                            <el-input v-model="dados.codigo" placeholder="FG-01"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Valor de referência (R$)">
                            <el-input-number v-model="dados.valor_referencia" :min="0" :precision="2" :step="50"
                                controls-position="right" style="width: 100%;"></el-input-number>
                            <small>Opcional — o sistema não é folha de pagamento.</small>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Base legal">
                    <el-input v-model="dados.base_legal" placeholder="Ex.: Lei Municipal nº 1.234/2020, art. 5º"></el-input>
                </el-form-item>

                <el-form-item label="Situação">
                    <el-switch v-model="dados.situacao" active-text="Ativa" inactive-text="Inativa"></el-switch>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/funcao-gratificada"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — item 27. */
export default {
    data: () => ({
        dados: { nome: '', codigo: '', valor_referencia: null, base_legal: '', situacao: true }
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/funcao-gratificada/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/funcao-gratificada')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/funcao-gratificada/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/funcao-gratificada/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Função gratificada salva.', type: 'success' })
                    this.$router.push('/admin/funcao-gratificada')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
